import React, { Component, PureComponent } from "react";
import { FormattedMessage } from "react-intl";
import "./_challengequiz.scss"
import { ConstantsContext } from "../../../utils/ConstantsContext";
import Axios from "../../../utils/request";
import { Quiz } from "../../../components/Quiz";
import ChallengeQuizSection from "./ChallengeQuizSection";
import { parseAxiosError, getHost } from "utils/APIUtils";
import SockJsClient from "react-stomp";
import Psend from "../etcpage/Psend";


class ChallengeQuiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      connected: false,
    };
  }

  solveQuiz = () => {
    const _data = {
      type: "solveQuiz",
      value: ""
    };
    // new BroadcastChannel("QUIZ_CHANNEL").postMessage(_data);
    if (this.props.onSendMessage) {
      this.props.onSendMessage(_data);
    }
  };

  solve = (quizId, answers, vars) => {
    return Axios.post(`/quiz/v2/quizzes/${quizId}/solve`, {
      answers: answers,
      vars: vars,
    }).then((response) => {
      return response;
    });
  };

  render() {
    const { data, startChallengeQuiz, curPage, viewType, classroomId, seq, lectureId, section, sectionIndex } = this.props;
    const { completed } = this.state;

    if (completed) {
      return <Psend/>;
    }

    return (
      <div className={"quetureranking-layout"}>
        {curPage == 0 && (
          <>
            <div className="small-title">
              <FormattedMessage id={"classroom.challengeQuizTitle"}/> {section.slice(0,sectionIndex+1).filter(e=> e.type === "CHALLENGE").length}
            </div>
          </>)}

        {curPage === 1 && (<ChallengeQuizSection
          onSendMessage={this.props.onSendMessage}
          data={data}
          solveQuiz={this.solveQuiz}
          classroomId={classroomId}
          viewType={viewType}
          seq={seq}
          lectureId={ lectureId}
          onSolve={this.solve}
        />)}

      </div>
    );
  }
};

export default ChallengeQuiz;
